import { Inject, Injectable } from '@angular/core';
import { Observable, from, firstValueFrom } from 'rxjs';
import { StripeCardNumberElement, StripeElementsOptions, CreatePaymentMethodData, PaymentMethod, StripeError, ConfirmCardSetupData, ConfirmCardSetupOptions, ConfirmCardPaymentData, ConfirmCardPaymentOptions, Stripe, loadStripe, StripeElements } from '@stripe/stripe-js';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, mergeMap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})

export class StripeConnectService {

    private _stripe: Stripe | null = null;
    private _stripeKey: string = '';
    private _stripePromise: Promise<Stripe | null> | null = null;

    constructor(
        private _httpClient: HttpClient
    ) {

    }

    private getStripePromise(): Promise<Stripe | null> {
        if (!this._stripePromise) {
            this._stripePromise = loadStripe(this._stripeKey);
        }
        return this._stripePromise;
    }

    public setKey(key: string): void {
        this._stripeKey = key;
        this._stripePromise = loadStripe(key);
    }

    public elements(elementOptions?: StripeElementsOptions | any): Observable<StripeElements | undefined> {
        return from(this.getStripePromise()).pipe(
            map(stripe => stripe?.elements(elementOptions))
        );
    }

    public createToken(stripeCardNumber: StripeCardNumberElement, data: { name: string }): Observable<any> {
        return from(this.getStripePromise()).pipe(
            mergeMap(stripe => from(stripe!.createToken(stripeCardNumber, data)))
        );
    }

    public createPaymentMethod(data: CreatePaymentMethodData): Observable<any> {
        return from(this.getStripePromise()).pipe(
            map(stripe => stripe?.createPaymentMethod(data))
        );
    }

    public confirmCardSetup(clientSecret: string, data?: ConfirmCardSetupData, options?: ConfirmCardSetupOptions ): Observable<any> {
        return from(this.getStripePromise()).pipe(
            map(stripe => stripe?.confirmCardSetup(clientSecret, data, options))
        );
    }

    public createPaymentIntent(data?: any) {
        return this._httpClient.post(`https://api.stripe.com/v1/payment_intents`, data)
    }

    public confirmCardPayment(clientSecret: string, data?: ConfirmCardPaymentData | undefined, options?: ConfirmCardPaymentOptions | undefined): Observable<any> {
        return from(this.getStripePromise()).pipe(
            map(stripe => stripe?.confirmCardPayment(clientSecret, data, options))
        );
    }
}